// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".f-14[data-v-66ea0a14]{font-size:14px !important}#login[data-v-66ea0a14] .left-icon svg path{fill:var(--stan-text-light-color)}", "",{"version":3,"sources":["webpack://src/pages/auth/Login.vue"],"names":[],"mappings":"AAAA,uBAAuB,yBAAyB,CAAC,4CAA4C,iCAAiC","sourcesContent":[".f-14[data-v-66ea0a14]{font-size:14px !important}#login[data-v-66ea0a14] .left-icon svg path{fill:var(--stan-text-light-color)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
